export default "__VITE_ASSET__lzA$LpVk__"